<!-- MR20260922: Updated control -->
<main class="page-main">

  <div class="container layout layout--emergency">

    <div class="layout__emergency">

      <div class="layout__emergency-inner">

        <div class="card card--emergency">

          <div class="card-body">

            <!-- MR20260922: Icon swapped to prototype's category-agnostic asset -->
            <div class="card__avatar card__avatar__code">
              <img src="assets/img/emergency-assistance-code.svg" class="img-fluid" alt="">
            </div>
            <h4>{{question.question_copy}}</h4>

            <div class="card__msg">
              <div class="rte">
                <p>{{question.question_prompt}}</p>
              </div>
            </div>

            <div class="card__form">

              <span class="assist-code">{{securityCode}}</span>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</main>

<!-- MR20260922: Footer/exit button added - was previously missing, leaving the screen with no way out -->
<footer class="question-tray">
  <div class="container">
    <div class="question-tray__controls">
      <div class="question-tray__btns">
        <a href="javascript:void(0);" (click)="onOkay()" class="button button--primary" id="next-question">Okay</a>
      </div>
    </div>
  </div>
</footer>